import { post } from '../core/HttpClient'
import cookies from 'js-cookie'
import { validateQuery } from './validate'
import FormActions from '../actions/FormActions'
import BookingActions from '../actions/BookingActions'
import MessageActions from '../actions/MessageActions'

const FETCHBOOKINGS_INTERVAL = 45000
const FETCHMESSAGES_INTERVAL = 1000 * 60 * 15
let bookingsInterval
let messagesInterval

export function initQueryParams (nextState, replace, callback) {
  let token
  if (validateQuery(nextState.location.query)) {
    token = nextState.location.query.token
  }

  if (token) {
    cookies.set('token', token, { expires: 1000 })
  } else {
    token = cookies.get('token')
  }

  if (!token) {
    replace('/error')
    callback()
  } else {
    post('/booking-assistant/users/auth', { token })
      .then(res => {
        console.log(res)
        if (res && res.token) {
          FormActions.initLocationParams(res)

          BookingActions.fetchBookings()
          MessageActions.fetchMessages()
        
          clearInterval(bookingsInterval)
          bookingsInterval = setInterval(() => {  
            BookingActions.fetchBookings()
          }, FETCHBOOKINGS_INTERVAL)

          clearInterval(messagesInterval)
          messagesInterval = setInterval(() => {
            MessageActions.fetchMessages()
          }, FETCHMESSAGES_INTERVAL)          
        } else {
          replace('/error')
        }
        callback()
      })
      .catch(err => {
        console.log(err)
        replace('/error')
        callback()
      })
  }
}
